import {Component, OnInit, ViewChild} from '@angular/core';
import ArrayStore from 'devextreme/data/array_store';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import {ReportRequest} from '../reports-toolbar/reports-toolbar.component';
import {TrailerInterventionService} from '../../stores/trailer-intervention.service';
import {LayoutService} from '../../home/layout.service';
import {durationToHoursStr, User} from 'shared';
import DataSource from 'devextreme/data/data_source';
import {DxPivotGridComponent} from 'devextreme-angular';

@Component({
  selector: 'app-reports-grid',
  templateUrl: './reports-grid.component.html',
  styleUrls: ['./reports-grid.component.scss']
})
export class ReportsGridComponent implements OnInit {

  ds: DataSource;
  dataSource: PivotGridDataSource;
  store: ArrayStore;
  @ViewChild(DxPivotGridComponent, {static: false})
  pivotGrid: DxPivotGridComponent;

  constructor(
    private service: TrailerInterventionService,
    public user: User,
  ) {
    this.ds = this.service.newDataSource({
      paginate: false,
    });

    this.store = new ArrayStore({
      key: 'id',
      data: [],
    });

    this.dataSource = new PivotGridDataSource({
      fields: [{
        caption: 'Domaine',
        width: 120,
        dataField: 'domain_name',
        area: 'row',
        sortBySummaryField: 'Total'
      }, {
        caption: 'Parcelle',
        dataField: 'field.name',
        width: 150,
        area: 'row'
      }, {
        caption: 'Tracteur',
        dataField: 'tractor_name',
        width: 150,
        area: 'row'
      }, {
        caption: 'Outil',
        dataField: 'trailer_name',
        width: 150,
        area: 'row'
      }, {
        caption: 'Operation',
        dataField: 'trailer_operation_type',
        width: 150,
        area: 'row'
      }, {
        caption: 'Mois',
        dataField: 'start_time',
        dataType: 'date',
        groupInterval: 'month',
        area: 'column'
      }, {
        caption: 'Jour',
        dataField: 'start_time',
        dataType: 'date',
        groupInterval: 'day',
        area: 'column'
      }, {
        caption: 'Superficie Travaillée Ha',
        dataField: 'working_area_ha',
        dataType: 'number',
        summaryType: 'sum',
        format: {type: 'fixedPoint', precision: 2},
        area: 'data'
      }, {
        caption: 'Debit horaire Ha/h',
        dataField: 'working_hectare_per_hour',
        dataType: 'number',
        summaryType: 'avg',
        format: {type: 'fixedPoint', precision: 2},
        area: 'data'
      }, {
        caption: 'Vitesse moyenne au travail KM/H',
        dataField: 'working_in_field_speed_avg',
        dataType: 'number',
        summaryType: 'avg',
        format: {type: 'fixedPoint', precision: 2},
        area: 'data'
      }, {
        caption: 'Consommation Gasoil L',
        dataField: 'total_fuel_consumption',
        dataType: 'number',
        format: {type: 'fixedPoint', precision: 2},
        summaryType: 'sum',
        area: 'data'
      }, {
        caption: 'Consommation Gasoil  L/Ha',
        dataField: 'fuel_consumption_per_hectare',
        dataType: 'number',
        summaryType: 'avg',
        format: {type: 'fixedPoint', precision: 2},
        area: 'data'
      }, {
        caption: 'Temps total',
        dataField: 'total_duration',
        dataType: 'number',
        summaryType: 'sum',
        format: durationToHoursStr,
        area: 'data'
      }, {
        caption: 'Temps Travail',
        dataField: 'total_working_duration',
        dataType: 'number',
        summaryType: 'sum',
        format: durationToHoursStr,
        area: 'data'
      }, {
        caption: 'Temps d\'arrêt',
        dataField: 'stop_working_duration',
        dataType: 'number',
        summaryType: 'sum',
        format: durationToHoursStr,
        area: 'data',
      }, {
        caption: 'Arret / Travail  %',
        dataField: 'stop_working_duration_percent',
        dataType: 'number',
        summaryType: 'avg',
        format: 'percent',
        area: 'data'
      }, {
        caption: 'Temps Trajet',
        dataField: 'total_road_duration',
        dataType: 'number',
        summaryType: 'sum',
        format: this.duration,
        area: 'data'
      }],
      store: this.store,
      retrieveFields: false,
    });
  }

  ngOnInit(): void {
  }

  duration(value) {
    return durationToHoursStr(value) + ' h';
  }

  hectareUnit(value) {
    return value.toFixed(2) + ' ha';
  }

  load(request: ReportRequest) {

    this.pivotGrid.instance.beginUpdate();
    this.store.clear();

    this.ds.filter([
      ['start_time', '>=', request.from],
      'and',
      ['start_time', '<=', request.to]
    ]);

    this.ds.load().then((all) => {
      const changes = [];
      all.forEach(i => {
        changes.push({type: 'insert', data: i});
      });
      this.store.push(changes);
      this.dataSource.reload();
      this.pivotGrid.instance.endUpdate();
    });


  }
}
